module.exports = __webpack_public_path__ + "img/picture_lrtt.c0c180fb.png";